import request from '@/utils/request'
const requestApi = (metod,url,params) => request(metod, url, params,); // 图书分类

export const serverApi = {
    requestApi,
}



// WEBPACK FOOTER //
// ./src/server/index.js